import axios from "axios";
import { kycUserInterceptor } from "../Common/interceptor";

const API_URL = process.env.REACT_APP_API_BASE_URL;

const KycUserService = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

KycUserService.interceptors.request.use(kycUserInterceptor);

export default KycUserService;